import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild, ViewEncapsulation
} from '@angular/core';
import {
  ActivatedRoute,
  Router
} from '@angular/router';
import { Store } from '@ngxs/store';

import { TranslateService } from '@ngx-translate/core';

import { JobDetailService } from './job-detail.service';

import { DatePipe } from '@angular/common';
import { DialogHelper, ExceptionHelper } from './../../../../helper';
import { Job, Equipment } from '../../../../model';
import * as $ from 'jquery';

import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';

import { OWL_datetime_formats } from './../../owl_datetime_formats';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ClearPreviousJob } from '../job-merge-customer/actions/previousJob.action';
import { ClearJob } from '../job-merge-customer/actions/job.action';
import { ClearCustomer } from '../job-merge-customer/actions/customer.action';
import { ClearJobDetail } from '../job-merge-customer/actions/job-detail.action';
import { ClearJobEquipment } from '../job-merge-customer/actions/job-equipment.action';
import { ClearRenewMode, AddRenewMode } from '../job-merge-customer/actions/renew-mode.action';

@Component({
  templateUrl: './job-detail.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
        {provide: OWL_DATE_TIME_FORMATS, useValue: OWL_datetime_formats},
  ],
})
export class JobDetailComponent implements OnInit {

  @ViewChild('dangerModal') dangerModal: any;
  redirect = true;

  id: string;
  job;
  equipmentList = new Array<Equipment>();
  equipmentsDataTable: any;
  pmDataTable: any;
  datesDataTable: any;
  pmEquipmentList: any[];
  pmDateList: any[];
  tcDate: any;

  editCompletionDate: boolean;
  completionDate: Date;
  contractStartDate: Date;
  contractEndDate: Date;
  isCompleted = false;
  today = new Date();
  displayNum = 6; // number of PM to be display
  pmNum = 0;
  cgNum = 0;
  current = 0;
  dis_previous = true;
  dis_next = false;

  constructor(
    private datePipe: DatePipe,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private jobDetailService: JobDetailService,
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private store: Store,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
    this.store.dispatch(new ClearPreviousJob());
    this.store.dispatch(new ClearJob());
    this.store.dispatch(new ClearJobDetail());
    this.store.dispatch(new ClearCustomer());
    this.store.dispatch(new ClearJobEquipment());
    this.store.dispatch(new ClearRenewMode());


  }

  ngOnInit() {
    // this.getDetail();
    // this.getEquipmentList();
    // this.getPMList();
    this.today.setHours(0, 0, 0, 0);
    this.editCompletionDate = false;
    this.loadDetailPage();
  }

  public getDetail(): void {
    this.jobDetailService.getDetail(this.id)
      .subscribe(
        data => {
          if (data) {
            this.job = data;
            this.completionDate = new Date(this.job.jobCompletionDate);
            this.completionDate.setHours(0, 0, 0, 0);

            this.contractStartDate = new Date(this.job.contractStartDate);
            this.contractStartDate.setHours(0, 0, 0, 0);
            if (this.job.jobCompletionDate != null && this.completionDate <= this.today ) {
              this.isCompleted = true;
            }
            else {
              this.isCompleted = false;
            }
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }

  public getEquipmentList(): void {
    this.jobDetailService.getEquipmentList(this.id)
      .subscribe(
        data => {
          if ($.fn.dataTable.isDataTable('#equipmentsDataTables')) {
            $('#equipmentsDataTables').DataTable().destroy();
          }

          this.equipmentList = data.equipmentListModel;
          this.chRef.detectChanges();

          const table: any = $('#equipmentsDataTables');
          this.equipmentsDataTable = table.DataTable({
            autoWidth: true,
            scrollX: true
          });
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }

  public getPMList(): void {
    this.jobDetailService.getPMList(this.id)
      .subscribe(
        data => {
          if ($.fn.dataTable.isDataTable('#pmsDataTables')) {
            $('#pmsDataTables').DataTable().destroy();
          }

          this.pmEquipmentList = data.jobPMModels;
          this.pmDateList = data.jobPMDateModels.jobPMDateModel;
          this.tcDate = data.jobPMDateModels.jobPMDateTCModel[0];
          this.pmNum = this.pmDateList.length;

          this.chRef.detectChanges();

          const pmTable: any = $('#pmsDataTables');
          this.pmDataTable = pmTable.DataTable({
            "autoWidth": false,
            "columnDefs": [
              { width: 75, targets: 0 },
              { width: 65, targets: 1 }
            ],
          });

          // $('#equipmentId').css({ width: "75px", minWidth: "75px", maxWidth: "75px" });
          // $('#productCategory').css({ width: "65px", minWidth: "65px", maxWidth: "65px" });

          const dateTable: any = $('#datesDataTables');
          this.datesDataTable = dateTable.DataTable({
            "paging":    false,
            "ordering":  false,
            "info":      false,
            "searching": false,
            "autoWidth": false,
            // "columnDefs": [
            // { width: 200, targets: 0 }
            // ],
          });

          $('#date').css({ width: "200px", minWidth: "200px", maxWidth: "200px" });

          this.cgNum = (this.pmNum-1) / this.displayNum - ( (this.pmNum-1) / this.displayNum) % 1 + 1;
          this.current = 1;

          for (let i = 2; i <= this.cgNum ; i++) {
            this.pmDataTable.columns( '.cg-' + i ).visible( false );
            this.datesDataTable.columns( '.cg-' + i ).visible( false );
          }

        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
      }
    );
  }

  public next_cg(): void {
    this.dis_previous = false;
    this.pmDataTable.columns( '.cg-' + this.current ).visible( false );
    this.datesDataTable.columns( '.cg-' + this.current ).visible( false );
    this.current++;
    this.pmDataTable.columns( '.cg-' + this.current ).visible( true );
    this.datesDataTable.columns( '.cg-' + this.current ).visible( true );

    if (this.current === this.cgNum) {
      this.dis_next = true;
    }
  }

  public previous_cg(): void {
    this.dis_next = false;
    this.pmDataTable.columns( '.cg-' + this.current ).visible( false );
    this.datesDataTable.columns( '.cg-' + this.current ).visible( false );
    this.current--;
    this.pmDataTable.columns( '.cg-' + this.current ).visible( true );
    this.datesDataTable.columns( '.cg-' + this.current ).visible( true );

    if (this.current === 1) {
      this.dis_previous = true;
    }
  }

  public showInput(): void {
    $('#oriCompletionDate').hide();
    $('#showInput').hide();

    this.editCompletionDate = true;

  }

  public completionDateChanged(): void {
    if (this.job.jobCompletionDate < this.contractStartDate) {
      $('#saveCompletionDate').attr('disabled', 'disabled');
    }
    else {
      $('#saveCompletionDate').removeAttr('disabled');
    }
  }

  public changeCompletionDate(): void {

    this.jobDetailService.changeCompletionDate(this.id, this.datePipe.transform( this.job.jobCompletionDate , 'yyyy-MM-dd') )
      .subscribe(
        data => {
          this.editCompletionDate = false;
          this.dialog.showModal('showSucModalBtn');
          this.job = null;

          // this.router.navigate([this.router.url]);
          this.ngOnInit();

        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;
      }
    );

  }
  public goMergeCustomer() {
    this.store.dispatch(new AddRenewMode({isSingleCustomer : false})).subscribe(res => {
      this.router.navigate(['/home/job/merge-customer/' + this.job.jobNumber], {
        skipLocationChange: true
      });
    });
  }
  public goMergeRenew() {
    this.store.dispatch(new AddRenewMode({isSingleCustomer : true})).subscribe(res => {
      this.router.navigate(['/home/job/merge-customer/' + this.job.jobNumber], {
        skipLocationChange: true
      });

    });
  }
  public goJobDetails(jobNumber): void {
    this.router.navigate(['/home/job/detail/' + jobNumber]);

    this.id = jobNumber;

    this.job = null;
    this.equipmentList = [];
    this.pmEquipmentList = [];
    this.pmDateList = [];
    this.tcDate = null;

    this.ngOnInit();

  }

  public loadDetailPage(): void {
    forkJoin(
      this.jobDetailService.getDetail(this.id),
      this.jobDetailService.getEquipmentList(this.id),
      this.jobDetailService.getPMList(this.id)
    ).subscribe(([jobDetail, equipmentList, pmList]) => {
      if (jobDetail) {
        this.job = jobDetail;
        this.completionDate = new Date(this.job.jobCompletionDate);
        this.completionDate.setHours(0, 0, 0, 0);

        this.contractStartDate = new Date(this.job.contractStartDate);
        this.contractStartDate.setHours(0, 0, 0, 0);
        this.contractEndDate = new Date(this.job.contractEndDate);
        this.contractEndDate.setHours(0, 0, 0, 0);
        if (this.job.jobCompletionDate != null && this.completionDate <= this.today) {
          this.isCompleted = true;
        } else {
          this.isCompleted = false;
        }
      }

      if (equipmentList) {
        if ($.fn.dataTable.isDataTable('#equipmentsDataTables')) {
          $('#equipmentsDataTables').DataTable().destroy();
        }

        this.equipmentList = equipmentList.equipmentListModel;
        this.chRef.detectChanges();

        const table: any = $('#equipmentsDataTables');
        this.equipmentsDataTable = table.DataTable({
          autoWidth: true,
          scrollX: true
        });
      }

      if (pmList) {
        if ($.fn.dataTable.isDataTable('#pmsDataTables')) {
          $('#pmsDataTables').DataTable().destroy();
        }

        this.pmEquipmentList = pmList.jobPMModels;
        this.pmDateList = pmList.jobPMDateModels.jobPMDateModel;
        this.tcDate = pmList.jobPMDateModels.jobPMDateTCModel[0];
        this.pmNum = this.pmDateList.length;

        this.chRef.detectChanges();

        const pmTable: any = $('#pmsDataTables');
        this.pmDataTable = pmTable.DataTable({
          autoWidth: false,
          columnDefs: [
            { width: 75, targets: 0 },
            { width: 65, targets: 1 }
          ],
        });

        // $('#equipmentId').css({ width: "75px", minWidth: "75px", maxWidth: "75px" });
        // $('#productCategory').css({ width: "65px", minWidth: "65px", maxWidth: "65px" });

        const dateTable: any = $('#datesDataTables');
        this.datesDataTable = dateTable.DataTable({
          paging: false,
          ordering: false,
          info: false,
          searching: false,
          autoWidth: false,
          // "columnDefs": [
          // { width: 200, targets: 0 }
          // ],
        });

        $('#date').css({ width: '200px', minWidth: '200px', maxWidth: '200px' });

        this.cgNum = (this.pmNum - 1) / this.displayNum - ((this.pmNum - 1) / this.displayNum) % 1 + 1;
        this.current = 1;

        for (let i = 2; i <= this.cgNum; i++) {
          this.pmDataTable.columns('.cg-' + i).visible(false);
          this.datesDataTable.columns('.cg-' + i).visible(false);
        }
      }

      this.chRef.detectChanges();
    }, err => {
      this.exception.showError(err, 'showDanModalBtn');
      this.redirect = true;
    });
  }
  public errorClose(): void {
    if (this.redirect) {
      this.router.navigate(['/home/job']);
    }
    else {
      this.dangerModal.hide();
    }
  }

  findIndex(pm, pmDateList, tc = 0) {
    const temp = pmDateList.filter(x => x.tc === tc && x.pmServiceId > 0);
    const index = temp.findIndex(p => p === pm);
    return index + 1;
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-detail/job-detail.component.ts